/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allocation_Accept_Successmessage2Inputs */

const en_coinvestments_allocation_accept_successmessage2 = /** @type {(inputs: Coinvestments_Allocation_Accept_Successmessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation accepted successfully`)
};

/**
* | output |
* | --- |
* | "Allocation accepted successfully" |
*
* @param {Coinvestments_Allocation_Accept_Successmessage2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allocation_accept_successmessage2 = /** @type {((inputs?: Coinvestments_Allocation_Accept_Successmessage2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allocation_Accept_Successmessage2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allocation_accept_successmessage2(inputs)
});
export { coinvestments_allocation_accept_successmessage2 as "coInvestments_allocation_accept_successMessage" }